export default "__VITE_ASSET__BZXuepPd__"